// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3460": "2e798511","3922": "57d5af93","4299": "ad87e371","4671": "b8e97fc7","5841": "52f0b707",}[chunkId] + ".css"
}